import { loadFont } from './comFunc';

class subtitle {
	constructor(sub) {
		this.text = sub.text;
		this.start = sub.startTime;
		this.end = sub.endTime;
		this.width = sub.outward.width;
		this.top = sub.outward.y;
		this.left = sub.outward.x;
		this.opacity = sub.outward.opacity;
		this.rotate = sub.outward.rotation;
		this.lineHeight = sub.lineHeight || 1;
		this.letterSpacing = sub.letterSpacing || 0;
		this.dropShadow = Object.assign({
			blur: 0,
			color: "#273F9F",
			spread: 0,
			x: 0,
			y: 0
		}, sub.dropShadow);
		this.font = Object.assign({
			color: "#303233",
			fontFamilyLabel: "方正黑体",
			fontFamilyUrl: "2018-5-16/1526467728442.TTF",
			fontSize: 54,
			fontStretch: "normal",
			fontStyle: "normal",
			fontWeight: "normal",
			myTextStroke: 1,
			myTextStrokeColor: "#ffffff",
			textAlign: "center",
			textDecoration: "none",
			wordBreak: "break-word",
			writingMode: "inherit"
		}, sub.font);

		this.show = false;
	}
	initDom(dom) {
		let font = this.font;
		loadFont(font.fontFamilyUrl);
    dom.style.font = `${font.fontStyle} ${font.fontWeight} ${font.fontSize}px / ${this.lineHeight} "${font.fontFamilyUrl.split('/').pop()}"`;
    dom.style.color = font.color;
    dom.style.textDecoration = font.textDecoration;
    dom.style.textAlign = font.textAlign;
    dom.style.wordBreak = font.wordBreak;
    dom.style.letterSpacing = `${this.letterSpacing*(~~(parseInt(font.fontSize)/10))}px`;
		dom.style.filter = `drop-shadow(${this.dropShadow.x}px ${this.dropShadow.y}px ${this.dropShadow.blur}px ${this.dropShadow.color})`;

		let a = font.myTextStroke > 0 ? font.myTextStroke : 0;
		let b = font.myTextStrokeColor;
		if (a > 0) {
			let str = [];
			str.push(`${a}px ${a}px 2px ${b}`);
			str.push(`${a}px ${-a}px 2px ${b}`);
			str.push(`${-a}px ${a}px 2px ${b}`);
			str.push(`${-a}px ${-a}px 2px ${b}`);
			for (let i = 0; i < a; i++) {
				str.push(`${a}px ${i}px 2px ${b}`);
				str.push(`${-a}px ${i}px 2px ${b}`);
				str.push(`${i}px ${a}px 2px ${b}`);
				str.push(`${i}px ${-a}px 2px ${b}`);
				str.push(`${i}px ${0}px 2px ${b}`);
				str.push(`${-i}px ${0}px 2px ${b}`);
				str.push(`${0}px ${i}px 2px ${b}`);
				str.push(`${0}px ${-i}px 2px ${b}`);
			}
			dom.style.textShadow = str.join(',')
		} else {
			dom.style['text-shadow'] = '';
		}
	}
	play(time) {
		if(time >= this.start && time < this.end) {
			this.show = true;
		} else {
			this.show = false;
		}
		return this.show;
	}
}

class Subtitles {
	constructor() {
		this.width = 1920;
		this.height = 1080;
		this.subtitles = [];
	}
	fromJson(json) {
		this.subtitles.length = 0;
		let subtitles = json.contents || [];
		for(let i = 0; i < subtitles.length; i++) {
			this.subtitles.push(new subtitle(subtitles[i]))
		}
	}
	play(time) {
		for(let i = 0; i < this.subtitles.length; i++) {
			if(this.subtitles[i].play(time)) break;
		}
	}
	initPlay() {
		for(let i = 0; i < this.subtitles.length; i++) {
			this.subtitles[i].show = false;
		}
	}
}

export default Subtitles;


// WEBPACK FOOTER //
// ./src/components/draftPreview/subtitle.js